<template>
  <div>
    <el-dialog
        :title="'Tạo điểm danh, nhận xét'"
        :visible.sync="showCreateAttendanceEvaluateDialog"
        width="600px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="10vh"
    >
      <div>
        <el-row>
          <el-col :span="2">
            <el-date-picker
                style="width: 150px"
                size="medium"
                v-model="dataInput.date"
                type="date"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Chọn ngày"
                :clearable="false"
            ></el-date-picker>
          </el-col>
          <el-col :span="2" :offset="5">
            <el-select
                size="medium"
                v-model="dataInput.idSchool"
                placeholder="Chọn trường"
                filterable
                clearable
                style="width: 250px"
            >
              <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.id+' - '+item.schoolName"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="2">
            <el-button
                size="small"
                :loading="buttonLoading1"
                @click="createAttendanceEvaluateManual('attendanceType')"
                type="primary"
            >Tạo điểm danh
            </el-button>
            </el-col>
          <el-col :span="2" :offset="5">
            <el-button
                :loading="buttonLoading2"
                size="small"
                @click="createAttendanceEvaluateManual('evaluateType')"
                type="primary"
            >Tạo nhận xét ngày
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OtherService from "@/services/CommonService/OtherService";

export default {
  props: {
    showCreateAttendanceEvaluateDialog: {
      type: Boolean,
      default: () => false
    },
    schoolList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataInput: {
        date: "",
        idSchool: "",
      },
      buttonLoading1: false,
      buttonLoading2: false,
      listSchool: [],
    };
  },

  methods: {
    closeDialog() {
      this.dataInput.date = "";
      this.dataInput.idSchool = "";
      this.buttonLoading1 = false
      this.buttonLoading2 = false
      this.$emit('close', false);
    },
    createAttendanceEvaluateManual(type) {
      let dataInputNew = {
        date: this.dataInput.date,
      };

      let typeText = type === "attendanceType" ? "ĐIỂM DANH" : "NHẬN XÉT";
      if (this.dataInput.date === "") {
        this.$message({
          message: "Chọn ngày tạo " + typeText,
          type: "error",
        });
        throw null;
      }
      let alertText = this.dataInput.idSchool === "" ? "cho TOÀN BỘ các trường" : "";
      this.$confirm(
          "Bạn có chắc chắn muốn tạo " + typeText + " " + alertText + " không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(async () => {
        type === "attendanceType" ? this.buttonLoading1 = true : this.buttonLoading2 = true;
        await OtherService.createAttendanceEvaluateRootFromDate(
            type,
            dataInputNew,
            this.dataInput.idSchool
        )
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.buttonLoading1 = false;
                this.buttonLoading2 = false;
              }, 1000);
            });
      });
    },
  },


};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
</style>
